import { useQuery } from 'react-query';

import { EventSignUp, getInterviewBlockSignUps } from '@features/enterpriseEvents';
import axiosInstance from '@server/axiosInstance';

type UseGetInterviewBlockSignUpsData = {
  status: number;
  message: string;
  object: EventSignUp[];
};

type useGetInterviewBlockSignUpsProps = {
  blockId?: number;
};

export const useGetInterviewBlockSignUps = ({
  blockId,
}: useGetInterviewBlockSignUpsProps) => {
  const signUpsKey = 'signups';

  const { data: interviewSignupsData } =
    useQuery<UseGetInterviewBlockSignUpsData>({
      queryKey: [signUpsKey],
      queryFn: () =>
        axiosInstance
          .post(getInterviewBlockSignUps, { block_id: blockId })
          .then((res) => res.data),
      enabled: Boolean(blockId),
      refetchOnWindowFocus: false,
    });
  return { interviewSignupsData };
};
